import { Button } from "@/_component/Common";
import { DashboardAction, DashboardCardConfig } from "@/_component/home/dashboard-profile-card/types";
import { useLanguageContext } from "@/hooks";

export interface RenewCardProps {
    config: DashboardCardConfig;
    executeAction: (action: DashboardAction) => void;
};

const RenewCard = (props: RenewCardProps) => {

    const { language } = useLanguageContext();

    return (
        <div className="bg-white rounded-4 p-3 shadow-sm border">
            <p className="mb-2">Plan has been expired</p>
            <Button warning solid rounded small onClick={() => props.executeAction(props.config.renewAction)}>
                <i className="bi bi-arrow-repeat me-2" />{language("label.renew_plan") || "Renew Plan"}
            </Button>
        </div>
    );
}

export default RenewCard;